"use client"

import styled from "@emotion/styled"
import { NewText } from "ui"
import CategoryCard from "./CategoryCard"
import { CategoriesArr } from "./JobsSearch"

const StyledGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 20px;
  column-gap: 16px;
  width: fit-content;
  ${(props) => props.theme.breakpoints.down("md")} {
    margin-bottom: 28px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: repeat(4, 1fr);
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    grid-template-columns: repeat(4, 1fr);
  }
`
const StyledWrapper = styled.div`
  display: flex;
  justify-content: center; /* Centers children horizontally */
  align-items: center;    /* Centers children vertically */
  flex-direction: column;
`

type Props = {
  categories: CategoriesArr
  sectionTitle?: string
  onCardClick: (id: number) => void
  categoryColors: {
    id: number
    color: any
  }[]
}

function CardGrid({
  categories,
  sectionTitle,
  onCardClick,
  categoryColors,
}: Props) {
  return (
    <StyledWrapper>
      {sectionTitle && (
        <NewText
          component={"h2"}
          largeDesktopFontSize={36}
          largeDesktopLineHeight="50.4px"
          desktopFontSize={24}
          desktopLineHeight={"33.6px"}
          mobileFontSize={20}
          mobileLineHeight={"28px"}
          marginBottom={"24px"}
          desktopFontWeight={500}
        >
          {sectionTitle}
        </NewText>
      )}
      <StyledGridContainer>
        {categories.map((el, index) => {
          return (
            <CategoryCard
              color={categoryColors.find((cat) => cat.id === el.id)?.color}
              key={el.name}
              data={el}
              index={index}
              onCardClick={onCardClick}
            />
          )
        })}
      </StyledGridContainer>
    </StyledWrapper>
  )
}

export default CardGrid
